import React, { useState } from "react";
import { Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import ModalComponent from "../../../components/modals";
import LaddaButton from "../../../components/buttons/laddaButton";
import SimpleSelect from "../../../components/selects/simpleSelect";
import { getYearsFrom } from "../../../constants/selectData";
import { icons } from "../../../constants";
import { postMassiveUploadInventary } from "../../../services/apiService";
import MassiveUploadFeedBack from "../../../components/modals/massiveUploadFeedBack";
import LoadingFeedback from "../../../components/loadingFeedback";

const MassiveUploadModal = ({
  open,
  onClose,
  title = "Carga Masiva",
  defaultYear = new Date().getFullYear()
}) => {
  const { control, setValue, getValues } = useForm();
  const yearOptions = React.useMemo(() => getYearsFrom(2020), []);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [massiveUploadFeedbackData, setMassiveUploadFeedbackData] = useState(null);
  const [feedbackModal, setFeedbackModal] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    severity: "success",
    summary: "",
    detail: ""
  });
  const inputRef = React.useRef(null);

  React.useEffect(() => {
    setValue("year", defaultYear);
  }, [defaultYear, setValue]);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const validExtensions = ["xlsx", "xls"];
    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (!validExtensions.includes(fileExtension)) {
      alert("Solo se permiten archivos Excel (.xlsx o .xls)");
      e.target.value = null;
      return;
    }
    setSelectedFile(file);
    // onFileSelected(file);
  };

  const openFeedBack = () => {
    setFeedbackModal(true);
  };

  const closeFeedback = () => {
    setFeedbackModal(false);
    setMassiveUploadFeedbackData(null);
  };

  const handleDownload = () => {
    const url = "/templates/BiomedicalEquipmetMassiveTemplate.xlsx";
    const a = document.createElement("a");
    a.href = url;
    a.download = "BiomedicalEquipmetMassiveTemplate.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  const handleMassiveUpload = () => {
    const year = getValues("year");

    if (!selectedFile) {
      alert("Selecciona un archivo primero");
      return;
    }

    if (!year) {
      alert("Selecciona un año");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("year", year);

    setUploading(true);
    postMassiveUploadInventary(formData, year)
      .then((res) => {
        const {
          attempted = 0,
          inserted = 0,
          updated = 0,
          failedInserts = 0
        } = res.data || {};
        const processedRows = inserted + updated;

        if (processedRows === 0) {
          setToastConfig({
            severity: "error",
            summary: "Archivo no válido",
            detail: "El archivo no contiene registros válidos."
          });
        } else if (failedInserts > 0) {
          setToastConfig({
            severity: "warn",
            summary: "Carga parcial",
            detail: `Se procesaron ${processedRows} de ${attempted} registros.`
          });
        } else {
          setToastConfig({
            severity: "success",
            summary: "Carga masiva completada",
            detail: `Se procesaron ${processedRows} registros correctamente.`
          });
        }
        setShowToast(true);

        setSelectedFile(null);

        setMassiveUploadFeedbackData(res.data);

        openFeedBack(true);

        const fileInput = document.getElementById("fileInput");
        if (fileInput) fileInput.value = "";
      })
      .catch(() => {
        setToastConfig({
          severity: "error",
          summary: "Error en carga masiva",
          detail: "Ocurrió un problema al subir el archivo."
        });
        setShowToast(true);
      })
      .finally(() => setUploading(false));
  };

  return (
    <ModalComponent
      open={open}
      handleClose={onClose}
      title=""
      width="600px"
      actions={<></>}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        }}
      >
        <span className="gm-title mt-20">{title}</span>

        <LaddaButton
          width={"180px"}
          margin={"0"}
          fontSize={"12px"}
          variant="outlined"
          onClick={handleDownload}
          backgroundColor="#FFFF"
          color={"#6A6AD8"}
          borderColor={"#6A6AD8"}
        >
          <div className="IHContainer align-center">
            {icons?.descargar && (
              <img
                className="btn-icon"
                src={icons.descargar}
                alt="Descargar"
                style={{ marginRight: 10 }}
              />
            )}
            Descargar plantilla
          </div>
        </LaddaButton>
      </div>

      <br />

      <LoadingFeedback loading={uploading} variant="spinner">
      <form onSubmit={(e) => e.preventDefault()}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={8} md={8}>
            <SimpleSelect
              name="year"
              control={control}
              options={yearOptions}
              defaultValue={defaultYear}
              onChange={(e) => setValue("year", e.target.value)}
              margin="0"
            />
          </Grid>

          <Grid item xs={12} sm={4} md={4}>
            <LaddaButton
              margin={"0"}
              width={"100%"}
              fontSize={"12px"}
              variant="contained"
              onClick={() => inputRef.current?.click()}
            >
              <div className="IHContainer align-center">
                {icons?.upload && (
                  <img
                    className="btn-icon"
                    src={icons.upload}
                    alt="Agregar"
                    style={{ marginRight: 10 }}
                  />
                )}
                <p>Agregar Archivo</p>
              </div>
            </LaddaButton>
            <input
              ref={inputRef}
              type="file"
              style={{ display: "none" }}
              accept=".xlsx,.xls"
              onChange={handleFileChange}
            />
            {selectedFile && (
              <p style={{ marginTop: 6, fontSize: 12 }}>
                Archivo: <b>{selectedFile.name}</b>
              </p>
            )}
          </Grid>

          <Grid
            item
            xs={12}
            container
            spacing={2}
            justifyContent="center"
            style={{ marginTop: -10 }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              container
              justifyContent="center"
              display="flex"
            >
              <LaddaButton
                width={"180px"}
                height={"40px"}
                fontSize={"12px"}
                variant="outlined"
                onClick={handleMassiveUpload}
              >
                <div className="IHContainer align-center">
                  {icons?.upload && (
                    <img
                      className="btn-icon"
                      src={icons.upload}
                      alt="Subir"
                      style={{ marginRight: 10 }}
                    />
                  )}
                  Subir Carga Masiva
                </div>
              </LaddaButton>
            </Grid>
          </Grid>
        </Grid>
      </form>
      </LoadingFeedback>

      <MassiveUploadFeedBack
        open={feedbackModal}
        handleClose={closeFeedback}
        title={""}
        data={massiveUploadFeedbackData}
        validationSchema={{
          section: "inventory",
          title: "Feedback de carga masiva - Inventario de Equipos Biomédicos"
        }}
      />
    </ModalComponent>
  );
};

export default MassiveUploadModal;
